import { render, staticRenderFns } from "./TxItem.vue?vue&type=template&id=5c66cc9a&scoped=true"
import script from "./TxItem.vue?vue&type=script&lang=js"
export * from "./TxItem.vue?vue&type=script&lang=js"
import style0 from "./TxItem.vue?vue&type=style&index=0&id=5c66cc9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c66cc9a",
  null
  
)

export default component.exports